import React, { useEffect } from 'react';
import FaqDefaultV2 from '@/components/FrequentlyQuestions/FaqDefaultV2';
import { locale } from '@/utils/locale';
import { HELP_CENTER_URL } from '@/config/urls/supportUrls';
import { useDispatch, useSelector } from 'react-redux';
import { loadFaqProductDetail } from '@/redux/actions/faq';

const FaqProductDetails = ({
  packageid, onSecondaryAction, secondaryButtonLabel, showSameWithoutQuestions, testId,
}) => {
  const questions = useSelector(state => state.faq.productDetail.questions);
  const loading = useSelector(state => state.faq.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    packageid && dispatch(loadFaqProductDetail(packageid));
  }, [dispatch, packageid]);

  const handleHelpCenterClick = () => {
    window.open(HELP_CENTER_URL, '_blank');
  };

  return (
    <FaqDefaultV2
      title={locale('help.frequentlyQuestions')}
      questions={questions}
      onPrimaryAction={handleHelpCenterClick}
      primaryActionLabel={locale('help.faqProductDetailsButton')}
      onSecondaryAction={onSecondaryAction}
      secondaryActionLabel={secondaryButtonLabel}
      height="full"
      loading={loading}
      showSameWithoutQuestions={showSameWithoutQuestions}
      testId={testId}
    />
  );
};

export default FaqProductDetails;
